<div class="month-day" [ngClass]="getClass()">
  <div class="month-day-inner"
    [ngbPopover]="tmplRateDetails" #popover="ngbPopover" container="body" placement="auto"
    popoverClass="popover-rate-details" triggers="manual" [autoClose]="true"
    (click)="openPopover(popover)">

    <div class="day">
      <span *ngIf="startOfMonth">{{day | epochUTC:'MMM'}}</span>
      {{day | epochUTC:'D'}}
    </div>

    <ng-container *ngIf="showContent">
      <table class="rates" *ngIf="data.rates && data.rates.length"
        [style.margin-top.px]="data.rates.length >= 4 ? 5 : 10">
        <tr class="rate" *ngFor="let rate of data.rates">
          <td class="label">
            <div [attr.title]="rate.label">{{rate.label}}:</div>
          </td>
          <td class="value" [ngClass]="{ 'value-base-rate': rate.baseRate }">
            <div *ngIf="isWeekend && rate.weekend" [attr.title]="rate.weekend">{{rate.weekend}}</div>
            <div *ngIf="!isWeekend || !rate.weekend" [attr.title]="rate.price">{{rate.price}}</div>
          </td>
        </tr>
      </table>

      <div *ngIf="showPopover && data.allRates?.length > 4" class="btn-more-channels"
          matTooltip="Click here to view the full list of channel adjustments."
          matTooltipPosition="below" matTooltipClass="text-center"
          (click)="openPopover(popover)">
          <i class="fal fa-plus-circle"></i>
      </div>
    </ng-container>

    <div class="nights" *ngIf="showContent && data.nights">
      <span class="far fa-moon"></span>
      {{data.nights}}
    </div>

  </div>
</div>

<ng-template #tmplRateDetails>
  <app-rate-details-popover
    module="rates-calendar"
    [date]="day"
    [rental]="rental"
    [rate]="data?.rateView"
    [rates]="data?.rateViews"
    [channels]="channels">
  </app-rate-details-popover>
</ng-template>
